import { Box, Heading, Image } from '@wix/design-system'
import classNames from 'classnames'
import React, { FC, memo } from 'react'
import { useMediaQuery } from 'react-responsive'

import { LARGE_DESKTOP, SMALL_DESKTOP } from '../../../breakpoints'
import Arrow from '../icons/Arrow.svg'
import Logos from '../icons/Logos.svg'
import s from './VisualBox.scss'

type Props = {
  src: string
  visualType: string
  backgroundColor?: string
  light?: boolean
  description?: string
  logos?: boolean
}

export const VisualBox: FC<Props> = memo(({ backgroundColor, src, description, light, logos = false, visualType }) => {
  const isLargeDesktopScreen = useMediaQuery(LARGE_DESKTOP)
  const isSmallDesktopScreen = useMediaQuery(SMALL_DESKTOP)

  return (
    <Box width="100%" backgroundColor={backgroundColor} verticalAlign="middle" align="center" direction="vertical">
      <Box width="100%" position="relative" direction="vertical">
        {visualType === 'image' ? (
          <Image width="100%" height="100%" fit="contain" transparent borderRadius={0} src={src} />
        ) : (
          <video width="100%" src={src} loop={true} autoPlay={true} muted={true} />
        )}
        <Box padding="0 108px 0 108px" gap="SP7" top={isSmallDesktopScreen ? '97%' : '100%'} direction="vertical">
          {description && (
            <Box gap="SP2">
              <Box width="40px" height="40px" position="relative" top="-15px" verticalAlign="middle" align="center">
                <Arrow stroke={light ? 'white' : 'black'} />
              </Box>
              <Box>
                <Heading
                  size="medium"
                  className={classNames(s.description, { [s.descriptionLargeDesktop]: isLargeDesktopScreen })}
                  light={light}
                >
                  {description}
                </Heading>
              </Box>
            </Box>
          )}
          {logos && <Logos width="100%" />}
        </Box>
      </Box>
    </Box>
  )
})
